import { CensorshipPreview } from './censorship-preview.model';
import { ContentMinimized } from './cms-vod-core/content-controller/minimized-content-model';
import { TrailerOperation } from './cms-vod-core/trailer-operation.model';
import { ContentMediaFile } from './content-media-file.model';
import { ContentNote } from './content-note.model';
import { ContentPoster } from './content-poster.model';
import { ContentTimeCode } from './content-timecode.model';
import { License } from './license.model';
import { Metadata } from './metadata.model';
import { VideoOperationProcess } from './vod-operations/video-operation-process-model';
import { PlanProfile } from './plan-profile/plan-profile.model';
import { LanguageOption } from './language-option.model';
import { VODStream } from './vod-stream.model';

export class Content {
  constructor(
    public id?: number,
    public censorshipPreview?: CensorshipPreview,
    public channelName?: string,
    public catchupId?: number,
    public comingSoon?: boolean,
    public contentMediaFiles?: ContentMediaFile[],
    public languageOptions?: LanguageOption[],
    public contentNotes?: ContentNote[],
    public contentStatus?: string, //['None', 'WaitingForMaterials', 'RawContent', 'InProgress', 'ReadyForPublish', 'Published', 'NoActiveLicense', 'Deleted'],
    public contentTimeCodes?: ContentTimeCode[],
    public contentType?: string[],
    public creationDate?: number,
    public deleteTime?: number,
    public fileOperationFailed?: boolean,
    public guid?: string,
    public isExternal?: boolean,
    public licenses?: License[],
    public mediaDeleted?: boolean,
    public metadata?: Metadata,
    public migrated?: boolean,
    public name?: string,
    public parentId?: number,
    public posters?: ContentPoster[],
    public type?: string,
    public urlName?: string,
    public videoOperationFailed?: boolean,
    public videoOperationFolderName?: string,
    public videoOperationProcessName?: string, // ['Encode', 'Qc1', 'SubtitleScriptCheck', 'ThirdParty', 'VideoEditing', 'Qc2', 'Transcoding1st', 'Qc3', 'Transfer', 'Transcoding2nd', 'Completed'],
    public videoOperationProcesses?: VideoOperationProcess[],
    public vodType?: string, //['Vod', 'Cutv']
    public local?: boolean,
    public activeLicense?: boolean,
    public cdrId?: string,
    public childCount?: number,
    public trailerCreationDate?: number,
    public isValidMetadata?: boolean,
    public isValidPoster?: boolean,
    public planned?: boolean,
    public preview?: boolean,
    public publishTime?: number,
    public unpublishTime?: number,
    public minimized?: ContentMinimized,
    public hasRawMedia?: boolean,
    public mwInternalCode?: string,
    public trailerOperationFailed?: boolean,
    public trailerOperationProcessName?: string,
    public thirdPartyTasks?: string,
    public generateTrailer?: boolean,
    public coomingSoon?: boolean,
    public downloadable?: boolean,
    public encryption?: boolean,
    public trailerOperation?: TrailerOperation,
    public trailerOperationProcesses?: VideoOperationProcess[],
    public serviceType?: string,
    public year?: string,
    public genreName?: string,
    public licenseMinStartTime?: string,
    public licenseMaxEndTime?: string,
    public trailerAssignee?: string,
    public trailerCompletionTime?: number,
    public trailerBroadCastTime?: number,
    public catchupVideoDownloaded?: boolean,
    public planMinStartTime?: number,
    public planMaxEndTime?: number,
    public videoMigrated?: boolean,
    public censorshipStatus?: string,
    public planProfiles?: PlanProfile[],
    public onlineEditorAssignee?: string,
    public sectionInfo?: boolean,
    public keywords?: string,
    public isAdult?: boolean,
    public provider?: string,
    public streams?: VODStream[],
    public seriesName?: string,
    public parentSeriesId?: number,
    public hidden?: boolean,
    public inheritedHidden?: boolean
  ) { }
}

export interface ContentPMin {
  id?: number;
  name?: string;
}
